import { useContext, useEffect } from 'react'

import { TitleContext, TitleContextData } from '../contexts';

export const useTitle = (): TitleContextData => {
  return useContext(TitleContext);
}

export const useSetTitle = (title: string): void => {
  const { setTitle } = useContext(TitleContext);
  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);  
}
